import { createRootRoute, Outlet } from '@tanstack/react-router';

import { Toaster } from '@keboola/design';

import { AuthProvider } from '../auth/AuthProvider';
import { NotFoundPage } from '../components/NotFoundPage';
import { RouteErrorPage } from '../components/RouteErrorPage';

export const Route = createRootRoute({
  component: RootLayout,
  // Both on the root so every route inherits them: a child route may override, but nothing may fall
  // through to TanStack's bare "Not Found" string or to React unmounting the tree on a throw.
  notFoundComponent: NotFoundPage,
  errorComponent: RouteErrorPage,
});

/**
 * The root owns only cross-cutting providers and the toast portal. Chrome is per-audience — the
 * public catalog, the auth screens, the vendor dashboard and the admin panel each have a different
 * shell — so it lives in the four layout routes below this, not here.
 */
function RootLayout() {
  return (
    <div className="tailwindcss-preflight">
      <AuthProvider>
        <Outlet />
      </AuthProvider>
      <Toaster />
    </div>
  );
}
